module.exports = __webpack_public_path__ + "static/media/corner-1.dfdb6c51.png";